import React, { Component } from 'react';

class ButtonCustom extends Component {

  render() {
    const { 
      children,
      className,
      btnId,
      disabled,
      onClick,
      buttonImg,
      type
    } = this.props

    return (
      <button className={ className } 
              id={ btnId } 
              type={ type }
              disabled={disabled}
              onClick={onClick}>
        { children &&  
          <span>
            { children }
          </span>   
        }
        { buttonImg &&  
          <img src={buttonImg} alt=""/> 
        }
      </button>
    )
  };
}

export default ButtonCustom;



// WEBPACK FOOTER //
// ./src/components/ButtonCustom/ButtonCustom.js